module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_3009.aae9f483.png";